import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompare } from '../context/CompareContext';
import { Scale, X } from 'lucide-react';

const CompareFloatingBar = () => {
  const { t } = useTranslation();
  const { productIds, remove, clear } = useCompare();

  if (productIds.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-gray-900 text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 max-w-[95vw]"
      data-testid="compare-floating-bar"
    >
      <Scale className="h-5 w-5 text-orange-400 flex-shrink-0" />
      <span className="font-medium whitespace-nowrap">
        {t('compare.bar_label', { count: productIds.length })}
      </span>
      <Link
        to="/compare"
        className="px-4 py-1.5 bg-orange-500 hover:bg-orange-600 rounded-lg font-semibold transition text-sm whitespace-nowrap"
        data-testid="compare-bar-go-btn"
      >
        {t('compare.bar_view')}
      </Link>
      <button
        onClick={clear}
        className="text-gray-400 hover:text-white transition"
        title={t('compare.clear_all')}
        data-testid="compare-bar-clear-btn"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default CompareFloatingBar;
